import { useEffect } from "react";
import LanguageSelector from "../components/LanguageSelector";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft, SearchX } from "lucide-react";

const NotFound = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Page Not Found";
  }, []);

  return (
    <>
      <LanguageSelector />
      <main className="px-4 py-16 md:p-16 min-h-[85dvh] flex items-center justify-center">
        <div className="max-w-lg w-full text-center">
          <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-khamco-primary/10 text-khamco-primary mb-6">
            <SearchX size={36} />
          </span>
          <p className="text-sm font-semibold tracking-widest text-khamco-ribbon uppercase mb-2">
            404
          </p>
          <h1 className="text-[2rem] md:text-[2.5rem] font-minimoBold text-khamco-secondary">
            {t("Page Not Found")}
          </h1>
          <p className="font-minimoMedium text-gray-500 my-6">
            {t("404-p-1")}{" "}
            <Link
              to="/home"
              className="text-khamco-ribbon font-semibold underline underline-offset-2 hover:text-khamco-primary transition-colors"
            >
              {t("404-p-2")}
            </Link>
            .
          </p>
          <Link
            to="/home"
            className="inline-flex items-center gap-2 bg-khamco-ribbon hover:bg-khamco-primary text-white font-semibold py-3 px-6 rounded-xl shadow-sm transition-colors"
          >
            <ArrowLeft size={18} />
            {t("Go Home")}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
